module.exports = __webpack_public_path__ + "img/bottle-blue.2c35ef42.svg";